import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import { useDispatch } from "react-redux";
import { shareReducer } from "./shareSlice";
import { DashboardReducer } from "./dashboardSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    share: shareReducer,
    dashboard: DashboardReducer,
  },
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware({
  //     serializableCheck: {
  //       // Ignore specific action types
  //       ignoredActions: ["customers/setCustomersDataSource"],
  //       // Ignore specific field paths
  //       ignoredPaths: ["customers.customersDataSource", "customers.customersDataSource[].SurchargeStartDate"],
  //     },
  //   }),
});

// Type definitions for Redux state and dispatch
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Strongly typed `useDispatch()` for async thunks
export const useAppDispatch: () => AppDispatch = useDispatch;
